import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import useGA4Tracking from './useGA4Tracking';

// Pages...
import Home from './pages/Home/Home';
const AboutUs     = lazy(() => import('./pages/AboutUs/AboutUs'));
const Events      = lazy(() => import('./pages/Events/Events'));
const EventDetail = lazy(() => import('./pages/Events/EventDetail'));
const ContactUs   = lazy(() => import('./pages/ContactUs/ContactUs'));
const Board       = lazy(() => import('./pages/BoardMembers/BoardMembers'));
const Membership  = lazy(() => import('./pages/Membership/Membership'));
const ClubsAndActivities     = lazy(() => import('./pages/AboutUs/ClubsAndActivities'));
const CharityAndVolunteering = lazy(() => import('./pages/AboutUs/CharityAndVolunteering'));
const OurPartners = lazy(() => import('./pages/AboutUs/OurPartners'));

function RouterContent() {
  useGA4Tracking('G-09LYMPE3FN'); // <-- Your Measurement ID

  return (
    <>
      <Navbar />
      <main className="app-main">
        <Suspense fallback={<div style={{ minHeight: '40vh' }} aria-hidden="true" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/about-us/our-team" element={<AboutUs />} />
            <Route path="/about-us/clubs-and-activities" element={<ClubsAndActivities />} />
            <Route path="/about-us/charity-and-volunteering" element={<CharityAndVolunteering />} />
            <Route path="/about-us/our-partners" element={<OurPartners />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/board" element={<Board />} />
            <Route path="/membership" element={<Membership />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Helmet>
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>TWIG – Tashkent Women’s International Group</title>
        <meta
          name="description"
          content="An English-speaking social club for international women in Uzbekistan."
        />
      </Helmet>
      <RouterContent />
    </BrowserRouter>
  );
}
